export const ROW_MODEL_TYPE = 'serverSide'
export const OUTBOUND_FILTER = 'Outbound-filter'
export const OUTBOUND_SORT = 'Outbound-sort'

export const SUPPORTED_OPERATION = 'supportedOperations'

export const USER_COLUMN_STATE = 'userColumnState'

export const DEFAULT_COLUMN = {
  sortable: true,
  resizable: true,
  rowHeight: 40,
  menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
}

export const DEFAULT_COLUMN_WITH_FILTER = {
  sortable: true,
  resizable: true,
  menuTabs: ['filterMenuTab'],
}

export const CLAIMS_FILE_COLUMN = {
  suppressMovable: true,
  sizeColumnsToFit: true,
  autoSizeColumn: true,
  menuTabs: ['filterMenuTab', 'generalMenuTab'],
}

export const SIDEBAR_COLUMN_FILTER = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressPivots: true,
        suppressPivotMode: true,
        suppressValues: true,
        suppressDragToPivot: true,
        suppressRowGroups: true,
      },
    },
    {
      id: 'filters',
      labelDefault: 'Filters',
      labelKey: 'filters',
      iconKey: 'filter',
      toolPanel: 'agFiltersToolPanel',
    },
  ],
}
